import paths from "@icarius-router/paths";
import {
    dateClassRule,
    dateFormatter,
    dateValueGetter,
    dateFilterParams,
    dateComparator,
} from "@icarius-table/date";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.calendarDefinition],
        config: {
            headerName: getLocalizedString("processPeriod"),
            field: "period",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.calendarDefinition],
        config: {
            headerName: getLocalizedString("calendarType"),
            field: "typeString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.calendarDefinition],
        config: {
            headerName: getLocalizedString("dateFrom"),
            field: "from",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            cellClass: "dateFormat",
        }
    },
    {
        pages: [paths.calendarDefinition],
        config: {
            headerName: getLocalizedString("dateEnd"),
            field: "to",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            cellClass: "dateFormat",
        }
    },
    {
        pages: [paths.calendarDefinition],
        config: {
            headerName: getLocalizedString("state"),
            field: "statusString",
            filter: "agSetColumnFilter",
        }
    },
]